import React from "react";
import LoginSection from "../../section/LoginSection";

function Login() {
  return (
    <div>
      <LoginSection />
    </div>
  );
}

export default Login;
